import { useEffect, useState } from 'react';
import { userProfileSelector, userDataRefreshedSelector } from 'state/slices/session';
import { useSelector } from './store';

export const useSessionValidation = (): boolean => {
  const [isValidSession, setValidSession] = useState(false);
  const userProfile = useSelector(userProfileSelector);
  const userId = userProfile?.id;
  const hasUserDataRefreshed = useSelector(userDataRefreshedSelector);
  useEffect(() => {
    setValidSession(!!userProfile);
  }, [hasUserDataRefreshed, userId]);
  return isValidSession;
};
